import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
} from "@mui/material";

export default function Home({ onExplore }) {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <Box
      sx={{
        backgroundColor: "#102e43",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        px: 2,
        pt: 1,
        pb: 0,
      }}
    >
      {/* Hero Section */}
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          color: "#e0e0e0",
          letterSpacing: 2,
          mb: 2,
        }}
      >
        Welcome to uBCoded
      </Typography>
      <Typography
        variant="h6"
        align="center"
        sx={{
          maxWidth: 700,
          mb: 7,
          lineHeight: 1.8,
          color: "#e0e0e0",
          letterSpacing: 1,
        }}
      >
        At <strong>uBCoded</strong>, a proud division of{" "}
        <strong>uBLogic</strong>, we turn digital dreams into reality. We
        specialize in crafting cutting-edge internet and business solutions that
        help companies thrive in the modern world. From designing visually
        stunning websites to developing custom software tailored to your needs,
        uBCoded is your partner for innovation.
      </Typography>

      {/* Services / Features Section */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="stretch"
        sx={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              backgroundColor: "#1b3a57",
              color: "#fff",
              minHeight: 280,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              transition: "transform 0.3s, box-shadow 0.3s",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
              },
            }}
          >
            <CardContent
              sx={{
                flex: 1,
                width: 380,
                overflow: "hidden",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alighnItems: "center",
                fontSize: 8,
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: "#e0e0e0", letterSpacing: 2 }}
              >
                Web Development
              </Typography>
              <Typography sx={{ color: "#e0e0e0", letterSpacing: 1 }}>
                We design and develop modern, responsive, and high-performing
                websites that help your business stand out online. Our focus is
                on creating user-friendly experiences that are visually
                engaging, fast, and optimized for success.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card
            sx={{
              backgroundColor: "#1b3a57",
              color: "#fff",
              minHeight: 280,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              transition: "transform 0.3s, box-shadow 0.3s",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
              },
            }}
          >
            <CardContent
              sx={{
                flex: 1,
                width: 380,
                overflow: "hidden",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alighnItems: "center",
                fontSize: 8,
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: "#e0e0e0", letterSpacing: 2 }}
              >
                Software Development
              </Typography>
              <Typography sx={{ color: "#e0e0e0", letterSpacing: 1 }}>
                We build powerful, reliable, and scalable software solutions
                tailored to your business needs. From custom applications to
                enterprise systems, our goal is to create software that improves
                efficiency, enhances user experience, and drives growth.
                <br />
                {expanded ? (
                  <>
                    <br />
                    Our development expertise covers a wide range of programming
                    languages and technologies, including:
                    <ul>
                      <li>
                        Frontend Development: HTML, CSS, JavaScript, React
                      </li>
                      <li>Backend Development: Java, C# (.NET)</li>
                    </ul>
                  </>
                ) : null}
              </Typography>
              <Button
                variant="text"
                sx={{ color: "#90caf9", mt: 2, alignSelf: "flex-start" }}
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "Show Less" : "Show More"}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card
            sx={{
              backgroundColor: "#1b3a57",
              color: "#fff",
              minHeight: 280,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              transition: "transform 0.3s, box-shadow 0.3s",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
              },
            }}
          >
            <CardContent
              sx={{
                flex: 1,
                width: 380,
                overflow: "hidden",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alighnItems: "center",
                fontSize: 8,
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: "#e0e0e0", letterSpacing: 2 }}
              >
                AI Playground
              </Typography>
              <Typography sx={{ color: "#e0e0e0", letterSpacing: 1 }}>
                A creative space where we design and build interactive
                components, apps, and games powered by AI
              </Typography>
              <Typography sx={{ color: "#e0e0e0", letterSpacing: 1 }}>
                — turning ideas into fun, functional digital experiences.
              </Typography>
              <Button
                variant="text"
                sx={{ color: "#90caf9", mt: 2, alignSelf: "flex-start" }}
                onClick={onExplore}
              >
                Explore
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Call to Action Section */}
      <Box sx={{ mt: 6, textAlign: "center" }}></Box>
    </Box>
  );
}
